var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 390 512",
    viewBox: "0 0 390 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m385.6 124.4-120-120c-2.8-2.8-6.6-4.4-10.6-4.4h-210c-24.8 0-45 20.2-45 45v422c0 24.8 20.2 45 45 45h300c24.8 0 45-20.2 45-45v-332c0-4.1-1.7-7.9-4.4-10.6zm-115.6-73.2 68.8 68.8h-53.8c-8.3 0-15-6.7-15-15v-53.8zm75 430.8h-300c-8.3 0-15-6.7-15-15v-422c0-8.3 6.7-15 15-15h195v75c0 24.8 20.2 45 45 45h75v317c0 8.3-6.7 15-15 15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m285 212h-180c-8.3 0-15 6.7-15 15s6.7 15 15 15h180c8.3 0 15-6.7 15-15s-6.7-15-15-15z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m285 272h-180c-8.3 0-15 6.7-15 15s6.7 15 15 15h180c8.3 0 15-6.7 15-15s-6.7-15-15-15z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m285 332h-180c-8.3 0-15 6.7-15 15s6.7 15 15 15h180c8.3 0 15-6.7 15-15s-6.7-15-15-15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m225 392h-120c-8.3 0-15 6.7-15 15s6.7 15 15 15h120c8.3 0 15-6.7 15-15s-6.7-15-15-15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.0c1d6c12c0271bdd88fa1be2abc1c544.svg";
export { ForwardRef as ReactComponent };